const sortChildFilters = (data) => {
  const map = new Map<number, any>()
  const roots: Array<any> = []

  data.forEach((filter) => {
    map.set(filter.id, { ...filter, filters: [] })
  })

  data.forEach((filter) => {
    if (filter.parent_filter_id !== null) {
      const parent = map.get(filter.parent_filter_id)
      if (parent) {
        parent.filters.push(map.get(filter.id))
      }
    } else {
      roots.push(map.get(filter.id))
    }
  })

  return roots
}

export default sortChildFilters
